import actionCreatorFactory from 'typescript-fsa';

import { Role } from '../../../core/api/common/common.types';
import reduxConfig from '../../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/common');

export const getRolesList = actionCreator.async<{}, Role[]>('ROLES_LIST');
